import { render, staticRenderFns } from "./HasAttic.vue?vue&type=template&id=2a8501c2&"
import script from "./HasAttic.vue?vue&type=script&lang=ts&"
export * from "./HasAttic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports